import styled from 'styled-components'

const Title = (props) => {
  const { text } = props

  return <PageView>{text}</PageView>
}

const PageView = styled.div`
  width: 100%;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: ${(p) => p.theme.color_level.grey.high};
`

export default Title
